import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { XMarkIcon } from '@heroicons/react/24/outline';

import { NotificationStatusEnum } from './constants';
import { useEffect } from 'react';

export interface IToastData {
  status: NotificationStatusEnum;
  title: string;
  description?: string;
  id: number;
  timeout?: number;
}

export interface IToastProps extends IToastData {
  onClose: (id: number) => void;
}

export const Toast = ({ status, title, description, id, timeout = 2000, onClose }: IToastProps) => {
  const getIcon = () => {
    switch (status) {
      case NotificationStatusEnum.SUCCESS:
        return <CheckCircleIcon className='w-8' />;
      case NotificationStatusEnum.WARNING:
        return <ExclamationTriangleIcon className='w-8' />;
      case NotificationStatusEnum.ERROR:
        return <ExclamationCircleIcon className='w-8' />;
      default:
        return null;
    }
  };

  const getColorClass = () => {
    switch (status) {
      case NotificationStatusEnum.SUCCESS:
        return 'text-white bg-success';
      case NotificationStatusEnum.WARNING:
        return 'text-black bg-secondary';
      case NotificationStatusEnum.ERROR:
        return 'text-white bg-red';
      default:
        return '';
    }
  };

  useEffect(() => {
    if (timeout === 0) return;

    const timeoutId = setTimeout(() => {
      onClose(id);
    }, timeout);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [id, onClose, timeout]);

  return (
    <div className='flex justify-end max-lg:justify-center my-2'>
      <div
        className={`relative lg:min-w-[400px] max-lg:w-[350px] flex flex-col p-4 border-2 rounded-lg border-none ${getColorClass()}`}
      >
        <div className='absolute right-2 top-2'>
          <button onClick={() => onClose(id)}>
            <XMarkIcon className='w-6 h-6 cursor-pointer' />
          </button>
        </div>
        <div className='flex flex-row items-center gap-4'>
          <div>{getIcon()}</div>
          <div>
            <p className={`${getColorClass()} uppercase text-lg max-lg:text-base font-semibold`}>{title}</p>
            <p className={`${getColorClass()} text-base max-lg:text-sm`}>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
